import {Box, CardMedia} from "@mui/material";

const ImageWithCredit = ({
                             image,
                             alt,
                             creditImage,
                             height = 100,
                             overlaySize = 32,
                             overlayPosition = {top: 0, right: 6},
                             borderRadius = "8px",
                             ...props
                         }) => {
    return (
        <Box sx={{position: "relative", display: "inline-block"}} {...props}>
            <CardMedia
                component="img"
                height={height}
                image={image}
                alt={alt}
                sx={{
                    width: "100%",
                    borderRadius,
                    objectFit: "cover",
                }}
            />

            {creditImage && (
                <Box
                    component="img"
                    src={creditImage}
                    alt="Credit logo"
                    sx={{
                        position: "absolute",
                        top: overlayPosition.top,
                        right: overlayPosition.right,
                        width: overlaySize,
                        height: overlaySize,
                        borderRadius,
                        backgroundColor: "rgba(255,255,255,0)",
                        p: 0,
                        boxShadow: 1,
                        objectFit: "contain",
                    }}
                />
            )}
        </Box>
    );
};

export default ImageWithCredit;
